<template>
    <div>
        <q-btn flat round icon="mdi-filter">
            <q-menu v-model="menuOpen">
                <div class="row no-wrap q-pa-md">
                    <div class="column q-gutter-md">
                        <div class="text-h6 q-mb-md">Filtros</div>
                        <GltnSelectEstadoField
                            v-model="filters.estado"
                            label="Seleccione Estado"
                        />
                        <GltnSelectCliente
                            v-model="filters.cliente"
                            label="Búsqueda de cliente"
                        />
                        <GltnSelectFuerzaVenta
                            v-model="filters.fuerzaVenta"
                            label="Seleccione Fuerza de Venta"
                        />
                        <GltnSelectProductoTipo
                            v-if="vista === 'items'"
                            v-model="filters.tipoProducto"
                            label="Seleccione Tipo de Producto"
                        />
                    </div>
                </div>
                <div class="row no-wrap q-pa-md justify-around">
                    <q-btn
                        flat
                        color="red"
                        label="Cancelar"
                        @click="cancelar"
                    />
                    <q-btn
                        flat
                        color="green"
                        label="Confirmar"
                        @click="confirmar"
                    />
                </div>
            </q-menu>
        </q-btn>
        <q-chip
            v-for="f in mappedFilters"
            :key="f"
            icon="mdi-filter-check"
            removable
            @remove="filterRemove(f.key)"
            :color="f?.value?.color"
            :class="{ 'text-white': f?.value?.color }"
            >{{ f.title }}: {{ f?.value?.label }}</q-chip
        >
    </div>
</template>

<script setup>
import { ref, computed, reactive, onMounted } from "vue";
import { useDefaultDataStore } from "@/stores/useDefaultDataStore.js";
import GltnSelectCliente from "@/components/form/GltnSelectCliente.vue";
import GltnSelectEstadoField from "@/components/form/GltnSelectEstadoField.vue";
import GltnSelectProductoTipo from "@/components/form/GltnSelectProductoTipo.vue";
import GltnSelectFuerzaVenta from "@/components/form/GltnSelectFuerzaVenta.vue";

const filters =  reactive({
    estado: null,
    cliente: null,
    tipoProducto: null,
    fuerzaVenta: null,
});
const modelValue = defineModel()
const vista = defineModel("vista")

const defaultData = useDefaultDataStore();
const menuOpen = ref(false);
const emits = defineEmits(["filters-apply", "filters-reset"]);
const filtersTitles = {
    estado: "Estado",
    cliente: "Cliente",
    tipoProducto: "Tipo de Producto",
    fuerzaVenta: "Fuerza de Venta"
};
const mappedFilters = computed(() => {
    return Object.entries(filters)
        .filter(([_, value]) => value)
        .map(([key, value]) => ({ key, value, title: filtersTitles[key] }));
});
const cancelar = () => {
    filters.estado = null;
    filters.cliente = null;
    filters.tipoProducto = null;
    filters.fuerzaVenta = null;
    emits("filters-reset");
    menuOpen.value = false;
};

const mappedFiltersValue = computed(() => {
    return mappedFilters.value.reduce((acc, { key, value }) => {
        acc[key] = value.value;
        return acc;
    }, {});
});
const filterRemove = (key) => {
    filters[key] = null;
    emits("filter-remove", { ...mappedFiltersValue.value });
};
const confirmar = () => {
    emits("filters-apply", { ...mappedFiltersValue.value });
    menuOpen.value = false;
    modelValue.value = { ...filters };
};

onMounted(() => {
    Object.assign(filters, defaultData.getPresupuestoGridFilters);
    emits("filters-apply", { ...mappedFiltersValue.value });
});

</script>
